import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {
    resolveSeverityBadge,
    SeverityBadgeVariant,
} from '../vehicle-monitoring/vehicle-monitoring.constants';

@Component({
    selector: 'app-severity-badge',
    standalone: true,
    imports: [CommonModule],
    template: `
        <span *ngIf="badge as resolved" class="severity-badge" [ngClass]="resolved.variant">
            {{ resolved.label }}
        </span>
    `,
    styles: [`
        .severity-badge {
            display: inline-flex;
            align-items: center;
            padding: 0.2rem 0.55rem;
            border-radius: 999px;
            font-size: 0.72rem;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            line-height: 1.2;
            white-space: nowrap;
        }

        .severity-badge.low {
            background: #DCFCE7;
            color: #16A34A;
        }

        .severity-badge.medium {
            background: #FFEDD5;
            color: #EA580C;
        }

        .severity-badge.high {
            background: #FEE2E2;
            color: #DC2626;
        }

        .severity-badge.critical {
            background: #FCE7F3;
            color: #BE185D;
        }
    `]
})
export class SeverityBadgeComponent {
    @Input() severity: string | null | undefined = '';
    @Input() displayLabel: string | null | undefined = '';

    get badge(): {label: string; variant: SeverityBadgeVariant} | null {
        return resolveSeverityBadge(this.severity, this.displayLabel);
    }
}
